module.exports = __webpack_public_path__ + "img/galeria-mascotes2.aed48322.jpg";